shadow$provide[0] = function(global,require,module,exports) {
module.exports=(React);
};